import errorHandler from '../utils/errorHandler';
import { toastSuccess, toastInfo, toastError } from '../utils/toastMessage';
import * as constants from '../constants/constants';
import { loaderStart, loaderFinish } from './loader';
import {
  getDefaultMenu,
  MEAL_DEFAULT_TIMES,
  CATEGORY_INGREDIENTS,
  EATING_TAGS,
  MEAL_TYPES_DICTIONARY,
} from '../constants/appConstants';
import generateUniqueId from '../utils/generateUniqueId';
import API from '../utils/API';
import { setQueryParameter, deleteQueryParameter } from '../utils/url-params';
import { setExceptCategories } from './setParams';
import { getTemplateSuccess } from './template';

export const toggleLoadingComplexMenu = () => {
  return {
    type: constants.TOGGLE_LOADING_COMPLEX_MENU,
  };
};

export const setMenuLoading = (data) => {
  return {
    type: constants.SET_MENU_LOADING,
    data,
  };
};

export const setComplexMenuId = (data) => {
  return {
    type: 'SET_COMPLEX_MENU_ID',
    data,
  };
};

export const setDayCount = (data) => {
  return {
    type: 'SET_DAYS_COUNT',
    data,
  };
};

export const setSameDaysCount = (data) => {
  return {
    type: 'SET_SAME_DAYS_COUNT',
    data,
  };
};

export const getMenuGeneratorTemplatesError = (message) => {
  return {
    type: constants.GET_MENU_GENERATOR_TEMPLATES_ERROR,
    payload: {
      message,
    },
  };
};

export const setTemplateWasEdited = (isTempaleWasEdited) => {
  return {
    type: constants.IS_TEMPLATE_WAS_EDITED,
    payload: {
      isTempaleWasEdited,
    },
  };
};

export const getUserMenusSuccess = (data) => {
  return {
    type: 'GET_USER_MENUS_SUCCESS',
    data,
  };
};

export const setMenuMenuGenerator = (menu) => {
  return {
    type: constants.SET_MENU_MENU_GENERATOR,
    payload: {
      menu,
    },
  };
};

export const getUserMenus = (userId) => {
  return (dispatch) => {
    dispatch(setMenuLoading(true));
    dispatch(loaderStart());
    API.get(`/menus?userid=${userId}`)
      .then((response) => {
        dispatch(getUserMenusSuccess(response.data));
        dispatch(setMenuLoading(false));
        dispatch(loaderFinish());
      })
      .catch(function (error) {
        dispatch(loaderFinish());
        dispatch(getUserMenusSuccess([]));
        dispatch(setMenuLoading(false));
        const errorConfig = {
          404: {
            type: 'info',
            message: 'Для выбраного пользователя нет меню',
          },
          400: {
            message: 'Получить меню пользователя не удалось',
          },
        };
        errorHandler(error.response.status, errorConfig);
      });
  };
};

export const changeDaysCount = (count) => {
  return (dispatch, getState) => {
    const { sameDaysCount } = getState().menu;
    if (+sameDaysCount > 2 && count === 2) {
      dispatch(setSameDaysCount('0'));
    }
    // eslint-disable-next-line prefer-template
    dispatch(setDayCount('' + count));
    dispatch(setMenuMenuGenerator(getDefaultMenu(count)));
  };
};

export const countDishValues = (dishData, valueName) => {
  const valuePerHundredGrams =
    // eslint-disable-next-line no-nested-ternary
    dishData.dish && dishData.dish[valueName]
      ? +dishData.dish[valueName]
      : dishData[valueName]
      ? +dishData[valueName]
      : 0;
  const countedValue = valuePerHundredGrams * (+dishData.quantity / 100);
  dishData[`counted_${valueName}`] = +countedValue.toFixed(2);
};

const transformMealsData = (dayDishesInfo, recurringDaysId) => {
  const newMealsData = [];
  // eslint-disable-next-line guard-for-in
  for (const mealName in dayDishesInfo) {
    let recurringMealsId = 0;
    if (!MEAL_TYPES_DICTIONARY[mealName]) continue;
    dayDishesInfo[mealName].forEach((dishData) => {
      recurringMealsId++;
      if (!dishData.id) dishData.id = generateUniqueId();
      if (recurringDaysId >= 0) {
        dishData.recurringMealsId = `${recurringDaysId}${MEAL_TYPES_DICTIONARY[mealName].order}${recurringMealsId}`;
      }
      if (!dishData.time) {
        dishData.time = MEAL_TYPES_DICTIONARY[mealName].time;
        if (dishData.dish.name === 'Вода') {
          dishData.time = '+ час';
          if (mealName === 'morning') dishData.time = 'Натощак';
        }
      }
      countDishValues(dishData, 'calories');
      countDishValues(dishData, 'proteins');
      countDishValues(dishData, 'fats');
      countDishValues(dishData, 'carbohydrates');
    });
    newMealsData.push({
      type: mealName,
      title: MEAL_TYPES_DICTIONARY[mealName].title,
      order: MEAL_TYPES_DICTIONARY[mealName].order,
      meals: dayDishesInfo[mealName],
    });
  }

  const newSortedMealsData = newMealsData.sort((current, prev) => {
    if (current.order > prev.order) {
      return 1;
    }
    if (current.order < prev.order) {
      return -1;
    }
    return 0;
  });
  return newSortedMealsData;
};

export const transformMenuStructure = (menu, numberOfRecurringDays) => {
  let changeRecurringDays = +numberOfRecurringDays;
  let recurringDaysId = 0;
  return menu.map((dayDishesInfo, i) => {
    if (+numberOfRecurringDays !== 0) {
      if (i / changeRecurringDays === 1) {
        recurringDaysId++;
        changeRecurringDays += +numberOfRecurringDays;
      }
      return transformMealsData(dayDishesInfo, recurringDaysId);
    }
    return transformMealsData(dayDishesInfo);
  });
};

export const setChosenEatings = (chosenEatings) => {
  return {
    type: constants.SET_CHOSEN_EATINGS,
    payload: {
      chosenEatings,
    },
  };
};

export const toggleEating = (eatingId) => {
  return (dispatch, getState) => {
    const { chosenEatings } = getState().menu;
    let newEatings = JSON.parse(JSON.stringify(chosenEatings));
    if (chosenEatings.includes(eatingId)) {
      newEatings = chosenEatings.filter((tagId) => tagId !== eatingId);
    } else {
      newEatings.push(eatingId);
    }
    dispatch(setChosenEatings(newEatings));
  };
};

export const toggleLoadMenuGeneratorTemplates = () => {
  return {
    type: constants.TOGGLE_LOAD_MENU_GENERATOR_TEMPLATES,
  };
};

export const getMenuGeneratorTemplatesSuccess = (data) => {
  return {
    type: constants.GET_MENU_GENERATOR_TEMPLATES_SUCCESS,
    payload: {
      data,
    },
  };
};

export const setSearchMenuGeneratorTemplateName = (name) => {
  return {
    type: constants.SET_SEARCH_MENU_GENERATOR_TEMPLATE_NAME,
    payload: {
      name,
    },
  };
};

export const setMenuGeneratorTemplatesPaginationPage = (numberPage) => {
  return {
    type: constants.SET_MENU_GENERATOR_TEMPLATES_PAGINATION_PAGE,
    payload: {
      numberPage,
    },
  };
};

export const setMenuGeneratorTemplate = (template) => {
  return {
    type: constants.SET_MENU_GENERATOR_TEMPLATE,
    payload: {
      template,
    },
  };
};

export const toggleChangeTheSameDays = () => {
  return {
    type: constants.TOGGLE_CHANGE_THE_SAME_DAYS,
  };
};

export const getComplexMenus = (complexId) => {
  return (dispatch, getState) => {
    dispatch(loaderStart());
    setQueryParameter('complex', complexId);

    API.get(`/complexes/${complexId}/food-course`)
      .then((response) => {
        // eslint-disable-next-line prefer-template
        dispatch(setDayCount('' + response.data.data.days));
        dispatch(setComplexMenuId(response.data.data.complex_menu_id));
        const numberOfRecurringDays = getState().menu.sameDaysCount;
        const transformedMenu = transformMenuStructure(
          response.data.data.menu,
          numberOfRecurringDays,
        );
        dispatch(setMenuMenuGenerator(transformedMenu));

        const menuFilters = response.data.data.filters;
        const categoryTagIds = [];
        const eatingTagIds = [];
        menuFilters.forEach((tag) => {
          if (tag.category_id === CATEGORY_INGREDIENTS) categoryTagIds.push(tag.tag_id);
          if (tag.category_id === EATING_TAGS) eatingTagIds.push(tag.tag_id);
        });
        dispatch(setExceptCategories(categoryTagIds));
        dispatch(setChosenEatings(eatingTagIds));
        dispatch(setMenuGeneratorTemplate(null)); // reset choosed template
        dispatch(loaderFinish());
        if (!response.data.data.menu.length) {
          toastInfo('У выбранного комплекса пустое меню');
          return;
        }
        // don't show toastr on /controlUsers page
        if (window.location.pathname !== '/controlUsers') {
          toastSuccess('Меню комплекса успешно установлено');
        }
        // eslint-disable-next-line prefer-template
        dispatch(setSameDaysCount('' + response.data.data.numberOfRecurringDays));
      })
      .catch(function (error) {
        dispatch(loaderFinish());
        dispatch(setComplexMenuId(-1));
        dispatch(setExceptCategories([]));
        const { allEatingsTags } = getState().getTags;
        const allEatingsTagsIds = allEatingsTags.map((tag) => tag.tag_id);
        dispatch(setChosenEatings(allEatingsTagsIds));
        deleteQueryParameter('complex');
        dispatch(setMenuMenuGenerator(getDefaultMenu()));
        const errorConfig = {
          404: {
            type: 'info',
            message: 'У выбранного комплекса нет меню',
          },
          400: {
            message: 'Получить меню комплекса не удалось',
          },
        };
        errorHandler(error.response.status, errorConfig);
      });
  };
};

export const getMenuGeneratorTemplates = (pageNumber = 1, name = '') => {
  return (dispatch) => {
    dispatch(toggleLoadMenuGeneratorTemplates());
    API.get(
      `/template?&template=1&page=${pageNumber}&title=${name}&tags=&userId=&selectedComplexPeriod=`, // from correct search
    )
      .then((response) => {
        dispatch(getMenuGeneratorTemplatesSuccess(response.data.data));
      })
      .catch(function (error) {
        if (error.response.status === 404)
          dispatch(getMenuGeneratorTemplatesError('Результатов не найдено.'));

        const errorConfig = {
          404: {
            message: 'Шаблонов не найдено',
          },
        };
        errorHandler(error.response.status, errorConfig);
      });
  };
};

export const transformMenuForFewerDays = (template, selectedDayCount) => {
  template.menu.splice(selectedDayCount);
  template.days = selectedDayCount;
  return template;
};

export const transformMenuForMoreDays = (template, selectedDayCount) => {
  const availableDay = template.days;
  const missingDay = selectedDayCount - availableDay;
  const emptyDay = {
    breakfast: [],
    breakfastSnack: [],
    date: 4,
    dinner: [],
    dinnerSnack: [],
    lunch: [],
    lunchSnack: [],
    menuid: generateUniqueId(),
    morning: [],
  };

  template.days = selectedDayCount;
  for (let i = 0; i < missingDay; i++) {
    template.menu[availableDay + i] = emptyDay;
  }

  return template;
};

export const transformMenuWithFewerDaysFromWithSpecificDay = (
  template,
  selectedDayCount,
  currentMenu,
  specificDay,
) => {
  currentMenu.splice(specificDay, template.days, ...template.menu);
  template.days = selectedDayCount;
  currentMenu.splice(selectedDayCount);
  const currentMenuWithDate = currentMenu.map((day, i) => {
    // update date
    day.date = i + 1;
    return day;
  });

  template.menu = currentMenuWithDate;

  return template;
};

export const transformMenuLargerThanTemplateBeginningWithSpecificDay = (
  template,
  selectedDayCount,
  currentMenu,
  specificDay,
) => {
  template.days = selectedDayCount;
  currentMenu.splice(specificDay, currentMenu - specificDay, ...template.menu); // add a menu starting from a specific day
  currentMenu.splice(selectedDayCount);
  const currentMenuWithDate = currentMenu.map((day, i) => {
    // update date
    day.date = i + 1;
    return day;
  });
  template.menu = currentMenuWithDate;
  return template;
};

export const transformCurrentMenu = (currentMenu) => {
  const transformMenu = currentMenu.map((day, i) => {
    const emptyDay = {
      breakfast: [],
      breakfastSnack: [],
      date: 4,
      dinner: [],
      dinnerSnack: [],
      lunch: [],
      lunchSnack: [],
      menuid: generateUniqueId(),
      morning: [],
    };

    day.map((eating) => {
      emptyDay[eating.type] = eating.meals;
      emptyDay.date = i + 1;
      return null;
    });
    return emptyDay;
  });
  return transformMenu;
};

export const setTemplateToMenuBlock = (idTemplate, specificDay) => {
  return (dispatch, getState) => {
    dispatch(loaderStart());
    const { selectedDayCount } = getState().menu;
    const { menu } = getState().menu;
    API.get(`/template/${idTemplate}`)
      .then((resp) => {
        dispatch(loaderFinish());
        dispatch(setSameDaysCount(`${resp.data.data.numberOfRecurringDays}`));
        let transformMenu = [];
        const currentMenu = menu;
        const transformedCurrentMenu = transformCurrentMenu(currentMenu);
        const countTemplateDays = +resp.data.data.days;
        if (+selectedDayCount !== countTemplateDays) {
          if (+selectedDayCount < countTemplateDays) {
            transformMenu = transformMenuLargerThanTemplateBeginningWithSpecificDay(
              resp.data.data,
              selectedDayCount,
              transformedCurrentMenu,
              specificDay,
            );
          } else if (+selectedDayCount > countTemplateDays) {
            transformMenu = transformMenuWithFewerDaysFromWithSpecificDay(
              resp.data.data,
              selectedDayCount,
              transformedCurrentMenu,
              specificDay,
            );
          }
        } else {
          transformMenu = resp.data.data;
        }
        if (specificDay > 0) dispatch(setTemplateWasEdited(true));
        const menuFilters = transformMenu.filters;
        const categoryTagIds = [];
        const eatingTagIds = [];
        menuFilters.forEach((tag) => {
          if (tag.category_id === CATEGORY_INGREDIENTS) categoryTagIds.push(tag.tag_id);
          if (tag.category_id === EATING_TAGS) eatingTagIds.push(tag.tag_id);
        });
        dispatch(setExceptCategories(categoryTagIds));
        dispatch(setChosenEatings(eatingTagIds));
        toastSuccess('Шаблон успешно установлен');
        dispatch(setMenuGeneratorTemplate(transformMenu));
        const numberOfRecurringDays = getState().menu.sameDaysCount;
        let transformedMenu = transformMenuStructure(transformMenu.menu, numberOfRecurringDays);
        if (+selectedDayCount !== countTemplateDays) {
          if (+selectedDayCount > countTemplateDays) {
            // eslint-disable-next-line no-use-before-define
            transformedMenu = transformRecurringMenuStructure(
              transformedMenu,
              numberOfRecurringDays,
            );
          }
        }
        dispatch(setMenuMenuGenerator(transformedMenu));
        dispatch(setDayCount(transformMenu.days));
        dispatch(getTemplateSuccess(resp.data.data));
      })
      .catch((err) => {
        dispatch(loaderFinish());
        dispatch(setMenuMenuGenerator(getDefaultMenu()));
        dispatch(setExceptCategories([]));
        const { allEatingsTags } = getState().getTags;
        const allEatingsTagsIds = allEatingsTags.map((tag) => tag.tag_id);
        dispatch(setChosenEatings(allEatingsTagsIds));
        if (err && err.response && err.response.status === 404)
          dispatch(getMenuGeneratorTemplatesError('У шаблона нет данных :('));
        const errorConfig = {
          404: {
            message: 'Данные шаблона не найдены',
          },
        };
        errorHandler(err.response.status, errorConfig);
      });
  };
};

const transformRecurringMealsData = (dayDishesInfo, recurringDaysId) => {
  const newMealsData = [];
  for (let i = 0; i < dayDishesInfo.length; i++) {
    const mealName = dayDishesInfo[i].type;
    let recurringMealsId = 0; // for uniqueness in dishes
    if (!MEAL_TYPES_DICTIONARY[mealName]) continue;

    for (let j = 0; j < dayDishesInfo[i].meals.length; j++) {
      const dishData = dayDishesInfo[i].meals[j];
      recurringMealsId++;
      if (!dishData.id) dishData.id = generateUniqueId();
      if (recurringDaysId >= 0) {
        dishData.recurringMealsId =
          // eslint-disable-next-line prefer-template
          '' + recurringDaysId + MEAL_TYPES_DICTIONARY[mealName].order + recurringMealsId; // order for uniqueness in eating
      }
      if (!dishData.time) {
        dishData.time = MEAL_TYPES_DICTIONARY[mealName].time;
        if (dishData.dish && dishData.dish.name === 'Вода') {
          dishData.time = '+ час';
          if (mealName === 'morning') dishData.time = 'Натощак';
        }
      }
      countDishValues(dishData, 'calories');
      countDishValues(dishData, 'proteins');
      countDishValues(dishData, 'fats');
      countDishValues(dishData, 'carbohydrates');
    }
    if (dayDishesInfo[i].meals.length === 0) {
      // recurringCleanMealsId - for cases when the meal is empty
      recurringMealsId++;
      newMealsData.push({
        type: mealName,
        title: MEAL_TYPES_DICTIONARY[mealName].title,
        order: MEAL_TYPES_DICTIONARY[mealName].order,
        meals: dayDishesInfo[i].meals,
        recurringCleanMealsId:
          // eslint-disable-next-line prefer-template
          '' + recurringDaysId + MEAL_TYPES_DICTIONARY[mealName].order + recurringMealsId,
      });
    } else
      newMealsData.push({
        type: mealName,
        title: MEAL_TYPES_DICTIONARY[mealName].title,
        order: MEAL_TYPES_DICTIONARY[mealName].order,
        meals: dayDishesInfo[i].meals,
      });
  }

  const newSortedMealsData = newMealsData.sort((current, prev) => {
    if (current.order > prev.order) {
      return 1;
    }
    if (current.order < prev.order) {
      return -1;
    }
    return 0;
  });
  return newSortedMealsData;
};

export const transformRecurringMenuStructure = (menu, numberOfRecurringDays) => {
  let changeRecurringDays = +numberOfRecurringDays;
  let recurringDaysId = 0; // to ensure the same id on the same days
  return menu.map((dayDishesInfo, i) => {
    if (+numberOfRecurringDays !== 0) {
      if (i / changeRecurringDays === 1) {
        recurringDaysId++;
        changeRecurringDays += +numberOfRecurringDays;
      }
      return transformRecurringMealsData(dayDishesInfo, recurringDaysId);
    }
    return dayDishesInfo;
  });
};

export const changePortion = (newMenu, dish, value) => {
  return (dispatch) => {
    dish.quantity = value;
    countDishValues(dish, 'calories');
    countDishValues(dish, 'proteins');
    countDishValues(dish, 'fats');
    countDishValues(dish, 'carbohydrates');
    dispatch(setMenuMenuGenerator(newMenu));
  };
};

export const changeDishPortion = (user, newDishData) => {
  if (!user.params.weight) {
    toastError('Вес пользователя не опеределен. Установлен вес порции по умолчанию');
    return 200;
  }
  if (user.params.weight < 60) {
    if (!newDishData.min_weight) return 100;
    return newDishData.min_weight;
  }
  if (user.params.weight >= 60 && user.params.weight < 80) {
    if (!newDishData.avg_weight) return 200;
    return newDishData.avg_weight;
  }
  if (user.params.weight >= 80) {
    if (!newDishData.max_weight) return 300;
    return newDishData.max_weight;
  }
};

export const changeDish = (newMenu, newDishData, newDishId, dishData, eating) => {
  return (dispatch, getState) => {
    const { user } = getState().reducers;
    if (newDishId) {
      dishData.dish = newDishData;
      let { time } = eating.meals[0];
      if (newDishData.name === 'Вода') {
        if (eating.type === 'morning') {
          time = 'Натощак';
        } else {
          time = '+ час';
        }
      }
      dishData.quantity = changeDishPortion(user, newDishData);
      dishData.time = time;
      countDishValues(dishData, 'calories');
      countDishValues(dishData, 'proteins');
      countDishValues(dishData, 'fats');
      countDishValues(dishData, 'carbohydrates');
    } else {
      dishData.quantity = 0;
      dishData.time = null;
      dishData.counted_calories = 0;
      dishData.counted_proteins = 0;
      dishData.counted_fats = 0;
      dishData.counted_carbohydrates = 0;
      dishData.dish = null;
    }
    dispatch(setMenuMenuGenerator(newMenu));
  };
};

export const changeRecurringDay = (
  newMenu,
  newDishData,
  newDishId,
  recurringMeals,
  whatChangeInDay,
  value,
) => {
  return (dispatch, getState) => {
    newMenu.forEach((menuForDay) => {
      menuForDay.forEach((eating) => {
        eating.meals.forEach((dishData) => {
          if (dishData.recurringMealsId === recurringMeals) {
            switch (whatChangeInDay) {
              case 'dish':
                dispatch(changeDish(newMenu, newDishData, newDishId, dishData, eating));
                break;
              case 'portion':
                dispatch(changePortion(newMenu, dishData, value));
                break;
              case 'deleteDish':
                eating.meals = eating.meals.filter(
                  (dishData) => dishData.recurringMealsId !== recurringMeals,
                );
                if (eating.meals.length === 0) {
                  const numberOfRecurringDays = getState().menu.sameDaysCount;
                  const transformMenu = transformRecurringMenuStructure(
                    newMenu,
                    numberOfRecurringDays,
                  );
                  dispatch(setMenuMenuGenerator(transformMenu));
                } else {
                  dispatch(setMenuMenuGenerator(newMenu));
                }
                break;
              case 'dishTime':
                dishData.time = value;
                dispatch(setMenuMenuGenerator(newMenu));
                break;
              default:
                break;
            }
          }
        });
      });
    });
  };
};

export const changeMenuGeneratorDishPortion = (positionDishId, value) => {
  return async (dispatch, getState) => {
    const newMenu = JSON.parse(JSON.stringify(getState().menu.menu));
    const { isChangeTheSameDays } = getState().menu;
    const numberOfRecurringDays = getState().menu.sameDaysCount;
    let recurringMeals = '';
    const whatChangeInDay = 'portion';
    newMenu.forEach((menuForDay) => {
      menuForDay.forEach((eating) => {
        eating.meals.forEach((dish) => {
          if (isChangeTheSameDays && dish.recurringMealsId && numberOfRecurringDays !== 0) {
            if (dish.id === positionDishId) {
              recurringMeals = dish.recurringMealsId;
              dispatch(changeRecurringDay(newMenu, '', '', recurringMeals, whatChangeInDay, value));
            }
          } else if (dish.id === positionDishId) {
            dispatch(changePortion(newMenu, dish, value));
          }
        });
      });
    });
  };
};

export const changeMenuGeneratorDish = (positionDishId, newDishId) => {
  return (dispatch, getState) => {
    const { dishes } = getState().reducers;
    const { isChangeTheSameDays } = getState().menu;
    const numberOfRecurringDays = getState().menu.sameDaysCount;
    const whatChangeInDay = 'dish';
    let recurringMeals = '';
    const newDishData = newDishId ? dishes.find((dish) => dish.id === newDishId) : null;
    const newMenu = JSON.parse(JSON.stringify(getState().menu.menu));
    newMenu.forEach((menuForDay) => {
      menuForDay.forEach((eating) => {
        eating.meals.forEach((dishData) => {
          if (isChangeTheSameDays && dishData.recurringMealsId && numberOfRecurringDays !== 0) {
            if (dishData.id === positionDishId) {
              recurringMeals = dishData.recurringMealsId;
              dispatch(
                changeRecurringDay(
                  newMenu,
                  newDishData,
                  newDishId,
                  recurringMeals,
                  whatChangeInDay,
                ),
              );
            }
          } else if (dishData.id === positionDishId) {
            dispatch(changeDish(newMenu, newDishData, newDishId, dishData, eating));
          }
        });
      });
    });
  };
};

export const searchRecurringDays = (newMenu, dayIndex, type) => {
  // to search for recurring days if the selected eating has dish
  const recurringDays = [];
  for (let i = 0; i < newMenu.length; i++) {
    const defaultEating = newMenu[dayIndex].find((day) => day.type === type);
    const eating = newMenu[i].find((day) => day.type === type);
    if (
      newMenu[i][0].meals[0] &&
      newMenu[dayIndex][0].meals[0].recurringMealsId === newMenu[i][0].meals[0].recurringMealsId
    ) {
      recurringDays.push(i);
    } else if (
      defaultEating &&
      defaultEating.meals[0] &&
      defaultEating.meals[0].recurringMealsId === eating.recurringCleanMealsId
    ) {
      recurringDays.push(i);
    } else if (
      defaultEating.recurringCleanMealsId &&
      defaultEating.recurringCleanMealsId === eating.recurringCleanMealsId
    ) {
      recurringDays.push(i);
    }
  }
  return recurringDays;
};

export const searchRecurringDaysInCleanMenu = (newMenu, dayIndex, type) => {
  // to search for recurring days if the selected eating hasn't dish
  const recurringDays = [];
  for (let i = 0; i < newMenu.length; i++) {
    const defaultEating = newMenu[dayIndex].find((day) => day.type === type);
    const eating = newMenu[i].find((day) => day.type === type);
    if (newMenu[dayIndex][0].recurringCleanMealsId === newMenu[i][0].recurringCleanMealsId) {
      recurringDays.push(i);
    } else if (defaultEating.recurringCleanMealsId === eating.recurringCleanMealsId) {
      recurringDays.push(i);
    } else if (
      eating.meals[0] &&
      defaultEating.recurringCleanMealsId === eating.meals[0].recurringMealsId
    ) {
      recurringDays.push(i);
    }
  }
  return recurringDays;
};

export const addMenuGeneratorDish = (dayIndex, type) => {
  return (dispatch, getState) => {
    const newMenu = JSON.parse(JSON.stringify(getState().menu.menu));
    const { isChangeTheSameDays } = getState().menu;
    const numberOfRecurringDays = getState().menu.sameDaysCount;
    let recurringDays = [];
    if (
      isChangeTheSameDays &&
      newMenu[dayIndex][0] &&
      !newMenu[dayIndex][0].meals[0] &&
      +numberOfRecurringDays !== 0
    ) {
      recurringDays = searchRecurringDaysInCleanMenu(newMenu, dayIndex, type);
    } else if (
      isChangeTheSameDays &&
      newMenu[dayIndex][0] &&
      newMenu[dayIndex][0].meals[0] &&
      newMenu[dayIndex][0].meals[0].recurringMealsId &&
      +numberOfRecurringDays !== 0
    ) {
      recurringDays = searchRecurringDays(newMenu, dayIndex, type);
    } else {
      recurringDays.push(dayIndex);
    }
    const UniqueId = generateUniqueId();
    for (let i = 0; i < recurringDays.length; i++) {
      newMenu[recurringDays[i]].forEach((eating) => {
        if (!eating.meals) {
          return;
        }
        if (eating.type === type) {
          let time = MEAL_DEFAULT_TIMES[eating.type];
          if (eating.meals.length) time = eating.meals[0].time;
          const emptyDish = {
            id: generateUniqueId(), // generate unique id
            dish: {
              name: null,
              calories: 0,
              carbohydrates: 0,
              fats: 0,
              proteins: 0,
            },
            counted_calories: 0,
            counted_carbohydrates: 0,
            counted_fats: 0,
            counted_proteins: 0,
            quantity: 0,
            time,
            recurringMealsId: UniqueId,
          };
          if (isChangeTheSameDays && eating.meals[0] && +numberOfRecurringDays !== 0) {
            // when adding a dish to a meal in which there was already a dish
            emptyDish.recurringMealsId = eating.meals[0].recurringMealsId + 1 + eating.meals.length; // for the uniqueness of the dishes
          } else if (
            isChangeTheSameDays &&
            eating.recurringCleanMealsId &&
            +numberOfRecurringDays !== 0
          ) {
            // when adding dishes to an empty eating
            emptyDish.recurringMealsId = eating.recurringCleanMealsId + 1 + eating.meals.length; // for the uniqueness of the dishes
          } else if (
            isChangeTheSameDays &&
            !eating.recurringCleanMealsId &&
            +numberOfRecurringDays !== 0
          ) {
            // eslint-disable-next-line prefer-template
            emptyDish.recurringMealsId = eating.order + '1' + eating.meals.length;
          }

          const mealWaterIndex = eating.meals.findIndex(
            (dishData) => dishData.dish.name === 'Вода',
          );
          if (mealWaterIndex !== -1) {
            eating.meals.splice(mealWaterIndex, 0, emptyDish); // insert empty dish before water
            dispatch(setMenuMenuGenerator(newMenu));
            return;
          }
          eating.meals.push(emptyDish);
          dispatch(setMenuMenuGenerator(newMenu));
        }
      });
    }
  };
};

export const deleteMenuGeneratorDish = (positionDishId) => {
  return (dispatch, getState) => {
    const newMenu = JSON.parse(JSON.stringify(getState().menu.menu));
    const { isChangeTheSameDays } = getState().menu;
    const numberOfRecurringDays = getState().menu.sameDaysCount;
    const whatChangeInDay = 'deleteDish';
    let recurringMeals = '';
    newMenu.forEach((menuForDay) => {
      menuForDay.forEach((eating) => {
        eating.meals.forEach((dishData) => {
          if (isChangeTheSameDays && dishData.recurringMealsId && +numberOfRecurringDays !== 0) {
            if (dishData.id === positionDishId) {
              recurringMeals = dishData.recurringMealsId;
              dispatch(changeRecurringDay(newMenu, '', '', recurringMeals, whatChangeInDay));
            }
          } else {
            if (dishData.id === positionDishId) {
              eating.meals = eating.meals.filter((dishData) => dishData.id !== positionDishId);
            }
            if (eating.meals.length === 0) {
              // if you deleted the last dish
              const numberOfRecurringDays = getState().menu.sameDaysCount;
              const transformMenu = transformRecurringMenuStructure(newMenu, numberOfRecurringDays);
              dispatch(setMenuMenuGenerator(transformMenu));
            } else {
              dispatch(setMenuMenuGenerator(newMenu));
            }
          }
        });
      });
    });
  };
};

export const changeMenuGeneratorMealTime = (dayIndex, type, timeValue) => {
  return (dispatch, getState) => {
    const newMenu = JSON.parse(JSON.stringify(getState().menu.menu));
    const { isChangeTheSameDays } = getState().menu;
    const numberOfRecurringDays = getState().menu.sameDaysCount;
    let recurringDays = [];
    if (
      isChangeTheSameDays &&
      newMenu[dayIndex][0] &&
      newMenu[dayIndex][0].meals[0] &&
      newMenu[dayIndex][0].meals[0].recurringMealsId &&
      +numberOfRecurringDays !== 0
    ) {
      recurringDays = searchRecurringDays(newMenu, dayIndex, type);
    } else {
      recurringDays.push(dayIndex);
    }
    for (let i = 0; i < recurringDays.length; i++) {
      newMenu[recurringDays[i]].forEach((eating) => {
        if (!eating.meals) {
          return;
        }

        if (eating.type === type) {
          eating.meals.forEach((dishData) => {
            if (dishData.dish.name !== 'Вода') {
              dishData.time = timeValue;
            }
          }); // water exception
          if (eating.meals.length >= 1 && eating.meals[0].dish.name === 'Вода') {
            eating.meals[0].time = timeValue;
          }
          dispatch(setMenuMenuGenerator(newMenu));
        }
      });
    }
  };
};

export const changeMenuGeneratorDishTime = (positionDishId, timeValue) => {
  return (dispatch, getState) => {
    const newMenu = JSON.parse(JSON.stringify(getState().menu.menu));
    const { isChangeTheSameDays } = getState().menu;
    const numberOfRecurringDays = getState().menu.sameDaysCount;
    const whatChangeInDay = 'dishTime';
    let recurringMeals = '';
    newMenu.forEach((menuForDay) => {
      menuForDay.forEach((eating) => {
        eating.meals.forEach((dishData) => {
          if (isChangeTheSameDays && dishData.recurringMealsId && +numberOfRecurringDays !== 0) {
            if (dishData.id === positionDishId) {
              recurringMeals = dishData.recurringMealsId;
              dispatch(
                changeRecurringDay(newMenu, '', '', recurringMeals, whatChangeInDay, timeValue),
              );
            }
          } else if (dishData.id === positionDishId) {
            dishData.time = timeValue;
            dispatch(setMenuMenuGenerator(newMenu));
          }
        });
      });
    });
  };
};

export const setUnwantedFood = (unwantedFood) => {
  return {
    type: constants.SET_UNWANTED_FOOD,
    payload: {
      unwantedFood,
    },
  };
};

export const setUnwantedFoodDay = (unwantedFoodDay) => {
  return {
    type: constants.SET_UNWANTED_FOOD_DAY,
    payload: {
      unwantedFoodDay,
    },
  };
};

export const checkUnwantedFood = (menu, category) => {
  return (dispatch, getState) => {
    const unwantedFood = [];
    const unwantedFoodDay = [];
    let menus = [];
    if (!menu) {
      menus = JSON.parse(JSON.stringify(getState().menu.menu));
    } else {
      menus = menu;
    }
    let templateTagsFilters = [];
    category && category.length
      ? (templateTagsFilters = category)
      : (templateTagsFilters = getState().templateGenerator.templateTagsFilters);
    menus.forEach((menuForDay, i) => {
      menuForDay.forEach((eating) => {
        eating.meals.forEach((dishData) => {
          dishData.dish &&
            dishData.dish.tags &&
            dishData.dish.tags.forEach((tag) => {
              templateTagsFilters.forEach((ingredientsTag) => {
                if (tag.tag_id === ingredientsTag) {
                  unwantedFood.push(dishData.dish);
                  unwantedFoodDay.push(i + 1);
                }
              });
            });
        });
      });
    });
    dispatch(setUnwantedFoodDay(unwantedFoodDay.filter((v, i, a) => a.indexOf(v) === i)));
    dispatch(setUnwantedFood(unwantedFood));
  };
};



// WEBPACK FOOTER //
// ./src/actions/menu.js